import { FormControl, FormField, FormItem, FormLabel } from "@/src/components/ui/form";
import { YachtsFiltersFormT } from "./yachts-filters.schema";
import { Checkbox } from "@/src/components/ui/checkbox";

const api = [
  {
    id: "NS",
    label: "NauSYS",
  },
  {
    id: "BM",
    label: "MMK (Booking Manager)",
  },
  {
    id: "CYA",
    label: "Central Yacht Agent",
  },
  {
    id: "Ankor",
    label: "Ankor",
  },
  {
    id: "Yachtfolio",
    label: "Yachtfolio",
  },
  {
    id: "Helm",
    label: "non-API yachts",
  },
] as const;

export const API = () => {
  return (
    <div>
      <h3 className="text-lg font-semibold col-span-full  mb-4">API</h3>
      <FormField<YachtsFiltersFormT, "provider">
        name="provider"
        render={() => (
          <FormItem>
            {api.map((item) => (
              <FormField
                key={item.id}
                name="provider"
                render={({ field }) => {
                  return (
                    <FormItem key={item.id} className="flex flex-row items-start space-x-3 space-y-0">
                      <FormControl>
                        <Checkbox
                          className="w-6 h-6 text-base leading-6"
                          checked={field.value?.includes(item.id)}
                          onCheckedChange={(checked) => {
                            return checked
                              ? field.onChange([...field.value, item.id])
                              : field.onChange(field.value?.filter((value: string) => value !== item.id));
                          }}
                        />
                      </FormControl>
                      <FormLabel className="font-normal text-base leading-6">{item.label}</FormLabel>
                    </FormItem>
                  );
                }}
              />
            ))}
          </FormItem>
        )}
      />
    </div>
  );
};
